

// 管理员
import Sportermeeting from '@/view/sportermeeting';
import SportermeetingMerge from '@/view/sportermeetingMerge';
import List from '@/view/list';
import printCertificate from '@/view/printCertificate';

let routerChild1 = [
  {
    path: "/printCertificate",
    name: "printCertificate",
    component: printCertificate,
    meta:{
      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      title: "成绩证书管理",
      parentRouter:'成绩证书管理',
      childRouter:'打印成绩证书',
      isPrint:true,
    }
  },
  {
    path: "/List",
    name: "List",
    component: List,
    meta:{
      title: "获奖证书管理",
      parentRouter:'获奖证书管理',
      childRouter:'运动会列表',
      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      isPrint:true,
    }
  },
  
]

let routerChild2 = [
  {
    path: "/sportermeeting",
    name: "sportermeeting",
    component: Sportermeeting,
    meta:{
      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      title: "运动会信息",
      parentRouter:'赛前设置',
      childRouter:'运动会信息'
    }
  },
  {
    path: "/sportermeetingMerge",
    name: "sportermeetingMerge",
    component: SportermeetingMerge,
    meta:{
      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      title: "运动会信息",
      parentRouter:'赛前设置',
      childRouter:'合并运动会列表'
    }
  }
]




export default  [routerChild1,routerChild2];


// WEBPACK FOOTER //
// ./src/router/dynamicRouter.js